
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, IconButton, MenuItem, TextField, Typography } from "@mui/material";
import { LayoutCrearDoc } from "../../layouts";
import { NumberFormatCustom, useValidarRoles } from "../../../hooks";
import { AvatarScreen } from "../../ui";
import { BotonesAndCargando } from "../../components/botones";
import { useCategoriaSelect, useInventarioSelect, useProductosXID } from "../../../hooks/cache";
import { useQueryClient } from "@tanstack/react-query";
import { startEditarProducto } from "../../../services";
import { useImagenStore } from "../../../stores";
import { iconos } from "../../../data";
import { generarIDGenerico } from "../../../helpers/operacionesStrings";



import Swal from "sweetalert2";
const initProducto = {
    nombre: "",
    codigo: "",
    costoMateria: "",
    costoProduccion: "",
    costoTotal: "",
    precioMinimoVenta: "",
    precioVenta: "",
    precioDistri: "",
    precioPublicista: "",
    precioEmpresa: "",
    categoria: "",
    recomendaciones: "",
    caracteristicas: "",
    uso: "",
    tipo: "",
    stocksItems:[],
};




export const ActualizarProducto = () => {

    const { id } = useParams();
    const queryClient = useQueryClient();
    const { isAdminRol } = useValidarRoles();
    const isAdministrador = isAdminRol();
    const { data=[] } = useCategoriaSelect();
    const { data:producto } = useProductosXID(id);
    const { data:stocks } = useInventarioSelect();

    const { imagen, valorImagen } = useImagenStore();
    const millares = NumberFormatCustom;
    const [cargando, setCargando] = useState(false);
    const [formProducto, setFormProducto ] = useState(initProducto);
    const { 
        nombre,
        codigo,
        costoMateria,
        costoProduccion,
        precioVenta,
        precioDistri,
        precioPublicista,
        precioEmpresa,
        recomendaciones,
        caracteristicas,
        uso,
        tipo,
        categoria,    
        costoTotal,
        precioMinimoVenta,
        stocksItems,
    } = formProducto;



    const handleInputChange = ({ target }) => {
        setFormProducto({
            ...formProducto,
            [target.name]: target.value
        });
    }


    useEffect( () => {
        if(producto){            
            setFormProducto({ 
                ...producto, 
                tipo: producto.tipo || '', 
                categoria: producto?.categoria?._id,
                stocksItems: Array.isArray(producto?.stocks) ? producto.stocks : [], 
            });
            valorImagen(producto.img)
        }
    }, [producto]);



    const handleActualizarProducto = async(e) => {
        e.preventDefault();
        const { isConfirmed } = await Swal.fire({
            title: 'Actualizar Producto',
            text: `¿Está seguro de actualizar este producto?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, actualizar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        const resp = await startEditarProducto({ ...formProducto, id, img: imagen });
        setCargando(false);
        if(resp) { queryClient.invalidateQueries({ queryKey: ['productos-todos'] }) }
    }



    const agregarStockItem = () => {
        setFormProducto(prev => ({ ...prev,
            stocksItems: [ 
                ...(Array.isArray(prev.stocksItems) ? prev.stocksItems : []),
                { id: generarIDGenerico(), id_stock: "", cantidad: "" },
            ],
        }));
    };


    const handleStockChange = (id, field, value) => {
        setFormProducto(prev => {
            const nuevosStocks = prev.stocksItems.map(item => item.id === id ? { ...item, [field]:value } : item);
            return { ...prev, stocksItems:nuevosStocks };
        });
    };



    const eliminarStockItem = (id) => {
        setFormProducto(prev => ({
            ...prev,
            stocksItems: prev.stocksItems.filter(item => item.id !== id),
        }));
    };




    return (

        <LayoutCrearDoc titulo='Actualizar Producto' add={false}>
            {/* <MostrarImagen /> */}
            <AvatarScreen carpeta="productos" />
            <form onSubmit={ handleActualizarProducto } >

                <Grid container spacing={3} sx={{mt:1}}>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Nombre'
                            type='text'
                            placeholder='Nombre'
                            fullWidth
                            name="nombre"
                            value={ nombre }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Codigo'
                            type='text'
                            placeholder='Codigo'
                            fullWidth
                            name="codigo"
                            value={ codigo }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Recomendaciones'
                            type='text'
                            placeholder='Recomendaciones'
                            fullWidth
                            name="recomendaciones"
                            value={ recomendaciones }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Caracteristicas'
                            type='text'
                            placeholder='Caracteristicas'
                            fullWidth
                            name="caracteristicas"
                            value={ caracteristicas }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Uso'
                            type='text'
                            placeholder='Uso'
                            fullWidth
                            name="uso"
                            value={ uso }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            variant="outlined"
                            select
                            label="Seleccione Tipo"
                            fullWidth
                            name='tipo'
                            value={ tipo }
                            onChange={ handleInputChange }
                        >
                            <MenuItem value="">Seleccione Un Tipo</MenuItem>
                            <MenuItem value="TARJETAS-VOLANTES-MEMBRETES">TARJETAS-VOLANTES-MEMBRETES</MenuItem>
                            <MenuItem value="CARPETAS-PLEGABLES">CARPETAS-PLEGABLES</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            select
                            label="Seleccione Categoria"
                            fullWidth
                            name='categoria'
                            value={ categoria }
                            onChange={ handleInputChange }
                        >
                            <MenuItem value=''> Seleccione Categoria</MenuItem>
                            {data.map( g => ( <MenuItem key={ g._id } value={ g._id } >{ g.nombre }</MenuItem> ))}
                        </TextField>
                    </Grid>

                    {(isAdministrador) &&
                    <>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required={ isAdministrador }
                            variant="outlined"
                            label='Costo Materia'
                            placeholder='Costo Materia'
                            fullWidth
                            name="costoMateria"
                            value={ costoMateria }
                            onChange={ handleInputChange }
                            InputProps={{
                                inputComponent: millares,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required={ isAdministrador }
                            variant="outlined"
                            label='Costo Produccion'
                            placeholder='Costo Produccion'
                            fullWidth
                            name="costoProduccion"
                            value={ costoProduccion }
                            onChange={ handleInputChange } 
                            InputProps={{
                                inputComponent: millares,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            disabled={true}
                            variant="outlined"
                            label='Costo Total'
                            placeholder='Costo Total'
                            fullWidth
                            name="costoTotal"
                            value={Number(costoMateria) + Number(costoProduccion)}
                            onChange={ handleInputChange } 
                            InputProps={{ inputComponent: millares }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            variant="outlined"
                            label='Precio Minimo Venta'
                            placeholder='Precio Minimo Venta'
                            fullWidth
                            name="precioMinimoVenta"
                            value={ precioMinimoVenta }
                            onChange={ handleInputChange } 
                            InputProps={{
                                inputComponent: millares,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required={ isAdministrador }
                            variant="outlined"
                            label='Precio Venta'
                            placeholder='Precio Venta'
                            fullWidth
                            name="precioVenta"
                            value={ precioVenta }
                            onChange={ handleInputChange } 
                            InputProps={{
                                inputComponent: millares,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required={ isAdministrador }
                            variant="outlined"
                            label='Precio Distri'
                            placeholder='Precio Distri'
                            fullWidth
                            name="precioDistri"
                            value={ precioDistri }
                            onChange={ handleInputChange } 
                            InputProps={{
                                inputComponent: millares,
                            }}
                        />
                    </Grid>  

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required={ isAdministrador }
                            variant="outlined"
                            label='Precio Publicista'
                            placeholder='Precio Publicista'
                            fullWidth
                            name="precioPublicista"
                            value={ precioPublicista }
                            onChange={ handleInputChange }
                            InputProps={{
                                inputComponent: millares,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField 
                            required={ isAdministrador }
                            variant="outlined"
                            label='Precio Empresa'
                            placeholder='Precio Empresa'
                            fullWidth
                            name="precioEmpresa"
                            value={ precioEmpresa }
                            onChange={ handleInputChange }
                            InputProps={{
                                inputComponent: millares,
                            }}
                        />
                    </Grid>
                    </>
                    }
                    


                    <Grid item xs={12}>
                        {(stocksItems?.length > 0) &&
                            <Typography sx={{fontSize:21, fontWeight:'bold', mt:2, mb:1}}>Stock Vinculado</Typography>
                        }
                        
                        <Grid container spacing={2}>
                        {stocksItems?.map((item) => (
                            <React.Fragment key={item.id}>
                                <Grid item xs={12} md={7}>
                                    <TextField select size="small"
                                        label="Stock" fullWidth
                                        value={item.id_stock}
                                        onChange={(e) => handleStockChange(item.id, "id_stock", e.target.value)}
                                    >
                                    <MenuItem value="">Seleccione Unidad de Medida</MenuItem>
                                        {stocks?.map((m) => ( <MenuItem value={m._id} key={m._id}>{m.nombre}</MenuItem> ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={10} md={4}>
                                    <TextField label="Cantidad" type="number" fullWidth
                                        size="small" value={item.cantidad}
                                        onChange={(e) => handleStockChange(item.id, "cantidad", e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={2} md={1} sx={{ display:"flex", alignItems:"center", justifyContent:'center' }}>
                                    <IconButton color="error" onClick={() => eliminarStockItem(item.id)}>
                                        {React.cloneElement(iconos['eliminar'])}
                                    </IconButton>
                                </Grid>
                            </React.Fragment>
                        ))}
                        </Grid>

                        <Grid item xs={12} sx={{mt:2}}>
                            <Button variant="contained" onClick={agregarStockItem}>
                                Agregar Stock
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Actualizar Producto'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>

            </form>
        </LayoutCrearDoc>
    )
}
